@if (showEntityBreadcrumbs) {
  <nav role="navigation" [attr.aria-label]="'Breadcrumb' | translate" class="max-app-width mx-auto">
    @if (elementsArray.length > 0) {
      <ol itemscope
        itemtype="http://schema.org/BreadcrumbList"
        class="entity-breadcrumbs max-app-width mx-auto">
        @for (item of elementsArray; track item; let last = $last; let i = $index) {
          <li itemscope
            itemtype="http://schema.org/ListItem"
            itemprop="itemListElement"
            >
            @if (item.title !== 'home' || homeType != 'icon') {
              <a itemprop="name" translate
                [routerLink]="item.url | parseUrl"
                [queryParams]="item.url | parseUrl: 'queryParams'"
                [fragment]="item.url | parseUrl: 'fragment'"
                [innerHTML]="item.title"
                class="cursor-pointer breadcrumbs-span"
                [ngClass]="{ 'pointer-events-none': !item.url || last == true}"
                [attr.aria-current]="last ? 'page'  : ''"
              ></a>
            }
            @if (item.title === 'home' && homeType == 'icon') {
              <a translate
                [routerLink]="item.url | parseUrl"
                [queryParams]="item.url | parseUrl: 'queryParams'"
                [fragment]="item.url | parseUrl: 'fragment'"
                class="cursor-pointer">
                <span itemprop="name" class="d-none" translate>Home</span>
                <mat-icon>home</mat-icon>
              </a>
            }
            @if (!last) {
              <span class="dividend">
                <i class="fas" [ngClass]="separator"></i>
              </span>
            }
            <meta itemprop="position" [content]="i+1"/>
            <meta itemprop="item" content="{{ this.currentURL + item.url }}"/>
          </li>
        }
      </ol>
    }
  </nav>
}
